import { loyallFunds } from '@/config';
import api from '@/services/api';

const loyallFundIds = loyallFunds.map((item) => item.houseFundId);

export default {
  async fetchList({ commit, rootState }) {
    commit('INCREMENT_LOADING_COUNT');

    try {
      const userFundIds = rootState.auth?.currentUser?.houseFunds ?? [];
      const houseFundIds = [...userFundIds, ...loyallFundIds];

      const houseFundList = await Promise.all(
        houseFundIds.map(async (houseFundId) => {
          const { data } = await api.houseFunds.getHouseFundDetails(houseFundId);
          return data;
        }),
      );

      commit('UPDATE_RESULTS', houseFundList);
      commit('UPDATE_RESPONSE_DATE', new Date());
      commit('SET_REQUEST_ERROR', null);
    } catch (error) {
      commit('SET_REQUEST_ERROR', error);
    } finally {
      commit('DECREMENT_LOADING_COUNT');
    }
  },
};
